<template>
  <header ref="tabs" class="generic-toolbar">
    <nav :class="{ '-sticky': sticky, '-stickyHeader': stickyHeader }">
      <div class="container">
        <ul>
          <li v-for="(link, i) in items" :key="link.text">
            <button v-if="category" type="button" class="h4" :class="{'-active': link.category === selectedCategory}" @click.prevent="selectCategory(i)">{{ link.text }}</button>
            <router-link v-else :to="localizedUrl + link.url" class="h4" :class="{'-active': $route.path === localizedUrl + link.url}" @click="selectCategory(i)">{{ link.text }}</router-link>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  name: 'GenericToolbar',
  props: ['item', 'items', 'siblingsComponents', 'pagePosition', 'category'],
  mixins: [ReadyHook],
  data() {
    return {
      sticky: false,
      stickyHeader: false,
      selectedCategory: 0
    }
  },
  computed: {
    localizedUrl () {
      const { url } = currentStoreView()
      return url
    }
  },
  mounted() {
    window.addEventListener('scroll', this.headerPosition)
    document.documentElement.style.setProperty('--generic-toolbar-h', `${this.$refs.tabs.offsetHeight}px`)
  },
  destroyed() {
    window.removeEventListener('scroll', this.headerPosition)
  },
  methods: {
    headerPosition() {
      if (window) {
        let elemRect = this.$refs.tabs.getBoundingClientRect()

        const getShouldBeSticky = () => {
          if (this.item.stickyOnScroll) {
            return window.pageYOffset > elemRect.top + document.documentElement.scrollTop
          }

          return window.pageYOffset + elemRect.top + document.documentElement.scrollTop > elemRect.top
        }

        if (getShouldBeSticky()) {
          this.sticky = document.querySelector('#header-site').classList.contains('-fixed')
          this.stickyHeader = document.querySelector('#header-site').classList.contains('-show')
        } else {
          this.sticky = false
          this.stickyHeader = false
        }
      }
    },
    selectCategory (category) {
      this.selectedCategory = category
      this.$emit('selectedCategory', category)
      this.scrollTo()
    },
    scrollTo() {
      if (window) {
        let bodyRect = document.body.getBoundingClientRect()
        let elemRect = this.$refs.tabs.getBoundingClientRect()
        let offset = elemRect.top - bodyRect.top
        // let decal = window.scrollY > offset ? 120 : 80
        window.scrollTo({
          top: offset - 120,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

header {
  position: relative;
  height: 8.1rem;
  @include bp(max md) {
    height: 5.1rem;
  }
}

nav {
  position: absolute;
  z-index: 30;
  top: 0;
  width: 100%;
  background: var(--zenith-white);

  .container {
    @include bp(max md) {
      padding: 0;
    }
  }

  &.-sticky {
    position: fixed;
    transition: all 0.2s ease-in-out;
    transform: translateY(-8rem);

    &:before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: .1rem;
      border-bottom: 1px solid rgba(#979797, 0.3);
    }

    ul:before {
      display: none;
    }

    &.-stickyHeader {
      transform: translateY(12rem);
      @include bp(max md) {
        transform: translateY(9rem);
      }
    }
  }

  ul {
    position: relative;
    margin: 0;
    padding: 0;
    list-style: none;
    overflow-x: auto;
    white-space: nowrap;
    text-align: center;
    display: flex;
    justify-content: space-evenly;

    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
      border-radius: 2px;
      background-color: #DFDFDF;
    }

    &::-webkit-scrollbar-thumb {
      background: #262626;
      border-radius: 2px;
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: .1rem;
      border-bottom: 1px solid rgba(#979797, 0.3);
    }

    @include bp(max md) {
      padding: 0 1.5rem;
    }

    li {
      padding: 0 3rem;
      display: inline-block;

      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        padding-right: 0;
      }

      a, button {
        display: block;
        padding: 3.4rem 0 0;
        height: 8rem;
        border: none;
        background: none;
        color: var(--zenith-theme-primary-lighter);
        text-transform: uppercase;
        transition: all 0.2s ease-in-out;
        border-bottom: 2px solid transparent;
        outline: none;

        @include bp(max md) {
          padding-top: 1.8rem;
          height: 5rem;
        }

        &:hover, &.-active {
          border-bottom: 2px solid var(--zenith-theme-primary);
        }
      }
    }
  }
}
</style>
